import axios from '../../http';

function initialState() {
  return {
    referralBranch: null,
    userRefId: null,
    userTrackingId: null,
    switchId: null,
    propertyDetails: []
  };
}

const state = initialState();

const getters = {};

const actions = {
  addAction({ commit }, { name, value }) {
    commit('updateActions', { name, value });
  },
  async saveActions({ state, commit, rootState }) {
    const { uid } = rootState.storage;
    const { switchId } = rootState.quote;
    const { referrerBranchCode } = rootState.storage;

    const data = [{
      userRefId: null,
      referralBranch: referrerBranchCode,
      userTrackingId: uid,
      switchId,
      propertyDetails: state.propertyDetails
    }];

    if (process.env.NODE_ENV == 'development') {
      console.log('trace', data);
      return commit('resetState');
    }

    try {
      const payload = data.map((item) => ({
        ...item,
        propertyDetails: item.propertyDetails.map(({ name, value }) => ({
          name,
          value: value !== null && typeof value === 'object' ? JSON.stringify(value) : value
        }))
      }));

      const res = await axios({
        method: 'POST',
        url: '/request/user/track-records',
        data: payload
      });

      commit('resetState');

      return res.data;
    } catch (err) {
      return err;
    }
  }
};

const mutations = {
  updateState(state, value) {
    state = Object.assign(state, value);
  },
  updateActions(state, { name, value }) {
    state.propertyDetails.push({ name, value });
  },
  resetState(state) {
    state = Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
